import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogTitle from "@material-ui/core/DialogTitle";
import { TextField, Typography } from "@material-ui/core";
import { ControlledSelect } from "./controlledSelect";

function AddSpecialPlateDialog({
    open,
    handleClose,
    data,
    onChange,
    handleFormSubmit,
}) {
    const activeOption = [
        {
            value: false,
            label: "No",
        },
        {
            value: true,
            label: "Yes",
        },
    ];

    return (
        <>
            <div>
                <Dialog open={open} onClose={handleClose}>
                    <DialogTitle id="subCategory-dialog-title">
                        Add Special Plate
                    </DialogTitle>
                    <DialogContent>
                        <Typography variant="subtitle1" component="p">
                            Please fill out the information below and submit.
                        </Typography>
                        <div
                            style={{ marginBottom: "5px", display: "block" }}
                        ></div>
                        <form onSubmit={handleFormSubmit}>
                            <TextField
                                type="text"
                                id="type"
                                value={data.type.value}
                                onChange={(e) => onChange(e)}
                                placeholder={"Enter Type"}
                                label="Type"
                                variant="outlined"
                                margin="dense"
                                fullWidth
                                required={true}
                            />
                            <TextField
                                type="number"
                                id="renewalAndReassignmentAmount"
                                value={data.renewalAndReassignmentAmount.value}
                                onChange={(e) => onChange(e)}
                                onKeyDown={(event) =>
                                    (event.key === "-" ||
                                        event.key === "Minus") &&
                                    event.preventDefault()
                                }
                                placeholder="Enter Renewal & Reassignment Amount*"
                                label="Renewal & Reassignment Amount"
                                variant="outlined"
                                margin="dense"
                                fullWidth
                                disabled={
                                    (data.renewalAndReassignmentSequential
                                        .value !== null &&
                                        data.renewalAndReassignmentSequential
                                            .value !== "") ||
                                    (data.renewalAndReassignmentPersonalized
                                        .value !== null &&
                                        data.renewalAndReassignmentPersonalized
                                            .value !== "")
                                }
                                required={
                                    (data.renewalAndReassignmentPersonalized
                                        .value === null ||
                                        data.renewalAndReassignmentPersonalized
                                            .value === "") &&
                                    (data.renewalAndReassignmentSequential
                                        .value === null ||
                                        data.renewalAndReassignmentSequential
                                            .value === "")
                                }
                                inputProps={{ min: 0 }}
                            />
                            <TextField
                                type="number"
                                id="renewalAndReassignmentSequential"
                                value={
                                    data.renewalAndReassignmentSequential.value
                                }
                                onChange={(e) => onChange(e)}
                                onKeyDown={(event) =>
                                    (event.key === "-" ||
                                        event.key === "Minus") &&
                                    event.preventDefault()
                                }
                                placeholder="Enter Renewal & Reassignment Sequential Amount*"
                                label="Renewal & Reassignment Sequential Amount"
                                variant="outlined"
                                margin="dense"
                                fullWidth
                                disabled={
                                    !!data.renewalAndReassignmentAmount.value ||
                                    data.renewalAndReassignmentAmount.value ===
                                        "0"
                                }
                                required={
                                    !!data.renewalAndReassignmentPersonalized
                                        .value ||
                                    data.renewalAndReassignmentPersonalized
                                        .value === "0"
                                }
                                inputProps={{ min: 0 }}
                            />
                            <TextField
                                type="number"
                                id="renewalAndReassignmentPersonalized"
                                value={
                                    data.renewalAndReassignmentPersonalized
                                        .value
                                }
                                onChange={(e) => onChange(e)}
                                onKeyDown={(event) =>
                                    (event.key === "-" ||
                                        event.key === "Minus") &&
                                    event.preventDefault()
                                }
                                placeholder="Enter Renewal & Reassignment Personalized Amount*"
                                label="Renewal & Reassignment Personalized Amount"
                                variant="outlined"
                                margin="dense"
                                fullWidth
                                disabled={
                                    !!data.renewalAndReassignmentAmount.value ||
                                    data.renewalAndReassignmentAmount.value ===
                                        "0"
                                }
                                required={
                                    !!data.renewalAndReassignmentSequential
                                        .value ||
                                    data.renewalAndReassignmentSequential
                                        .value === "0"
                                }
                                inputProps={{ min: 0 }}
                            />
                            <TextField
                                type="number"
                                id="reassignmentAmount"
                                value={data.reassignmentAmount.value}
                                onChange={(e) => onChange(e)}
                                onKeyDown={(event) =>
                                    (event.key === "-" ||
                                        event.key === "Minus") &&
                                    event.preventDefault()
                                }
                                placeholder="Enter Reassignment Amount*"
                                label="Reassignment Amount"
                                variant="outlined"
                                margin="dense"
                                fullWidth
                                disabled={
                                    (data.reassignmentSequential.value !==
                                        null &&
                                        data.reassignmentSequential.value !==
                                            "") ||
                                    (data.reassignmentPersonalized.value !==
                                        null &&
                                        data.reassignmentPersonalized.value !==
                                            "")
                                }
                                required={
                                    (data.reassignmentPersonalized.value ===
                                        null ||
                                        data.reassignmentPersonalized.value ===
                                            "") &&
                                    (data.reassignmentSequential.value ===
                                        null ||
                                        data.reassignmentSequential.value ===
                                            "")
                                }
                                inputProps={{ min: 0 }}
                            />
                            <TextField
                                type="number"
                                id="reassignmentSequential"
                                value={data.reassignmentSequential.value}
                                onChange={(e) => onChange(e)}
                                onKeyDown={(event) =>
                                    (event.key === "-" ||
                                        event.key === "Minus") &&
                                    event.preventDefault()
                                }
                                placeholder="Enter Reassignment Sequential Amount*"
                                label="Reassignment Sequential Amount"
                                variant="outlined"
                                margin="dense"
                                fullWidth
                                disabled={
                                    !!data.reassignmentAmount.value ||
                                    data.reassignmentAmount.value === "0"
                                }
                                required={
                                    !!data.reassignmentPersonalized.value ||
                                    data.reassignmentPersonalized.value === "0"
                                }
                                inputProps={{ min: 0 }}
                            />
                            <TextField
                                type="number"
                                id="reassignmentPersonalized"
                                value={data.reassignmentPersonalized.value}
                                onChange={(e) => onChange(e)}
                                onKeyDown={(event) =>
                                    (event.key === "-" ||
                                        event.key === "Minus") &&
                                    event.preventDefault()
                                }
                                placeholder="Enter Reassignment Personalized Amount*"
                                label="Reassignment Personalized Amount"
                                variant="outlined"
                                margin="dense"
                                fullWidth
                                disabled={
                                    !!data.reassignmentAmount.value ||
                                    data.reassignmentAmount.value === "0"
                                }
                                required={
                                    !!data.reassignmentSequential.value ||
                                    data.reassignmentSequential.value === "0"
                                }
                                inputProps={{ min: 0 }}
                            />
                            <ControlledSelect
                                id="isActive"
                                label="Is Active*"
                                value={data.isActive.value}
                                options={activeOption}
                                onChange={(e) => onChange(e)}
                                hasError={data.isActive.hasError}
                                includeAllFlag="false"
                            />
                            <DialogActions>
                                <Button
                                    onClick={handleClose}
                                    color="secondary"
                                    variant="outlined"
                                >
                                    Cancel
                                </Button>
                                <Button
                                    type="submit"
                                    color="primary"
                                    variant="contained"
                                >
                                    Submit
                                </Button>
                            </DialogActions>
                        </form>
                    </DialogContent>
                </Dialog>
            </div>
        </>
    );
}

export default AddSpecialPlateDialog;
